import React from "react";

import Heading from "@busbud/design-system-components/dist/Heading";
import Stack from "@busbud/design-system-components/dist/Stack";
import Text from "@busbud/design-system-components/dist/Text";

import { LinearProgressBar } from "@app/components/linear-progress-bar";
import { useAppContext } from "@app/helpers/hooks";

import { useStyles } from "./cancellation-progress.styles";
import { MapIllustration } from "../../illustrations/map";
import { CancelDialog } from "../cancel-dialog";

export const CancellationProgress: React.FC = () => {
  const { translator } = useAppContext();
  const { classes } = useStyles();

  const message = (
    <Stack direction="column" alignItems="center" spacing={1}>
      <div className={classes.illustrationContainer}>
        <MapIllustration />
      </div>
      <Heading size="sm" align="center">
        {translator.t("!account.trip-details.cancellation-progress.title")}
      </Heading>
      <Text size="lg" color="text.secondary.opaque" align="center">
        {translator.t("!account.trip-details.cancellation-progress.message")}
      </Text>
      <LinearProgressBar className={classes.gutter} quick_start />
    </Stack>
  );

  return (
    <CancelDialog
      message={message}
      classes={{
        box: classes.box
      }}
    />
  );
};
